/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIRootAccount } from './APIRootAccount';
import {
    APIRootAccountFromJSON,
    APIRootAccountFromJSONTyped,
    APIRootAccountToJSON,
} from './APIRootAccount';

/**
 * 
 * @export
 * @interface APIOrganizationAutocompleteSuggestion
 */
export interface APIOrganizationAutocompleteSuggestion {
    /**
     * 
     * @type {string}
     * @memberof APIOrganizationAutocompleteSuggestion
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof APIOrganizationAutocompleteSuggestion
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof APIOrganizationAutocompleteSuggestion
     */
    vatNumber?: string;
    /**
     * 
     * @type {APIRootAccount}
     * @memberof APIOrganizationAutocompleteSuggestion
     */
    rootAccount?: APIRootAccount | null;
}

/**
 * Check if a given object implements the APIOrganizationAutocompleteSuggestion interface.
 */
export function instanceOfAPIOrganizationAutocompleteSuggestion(value: object): value is APIOrganizationAutocompleteSuggestion {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function APIOrganizationAutocompleteSuggestionFromJSON(json: any): APIOrganizationAutocompleteSuggestion {
    return APIOrganizationAutocompleteSuggestionFromJSONTyped(json, false);
}

export function APIOrganizationAutocompleteSuggestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIOrganizationAutocompleteSuggestion {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'vatNumber': json['vat_number'] == null ? undefined : json['vat_number'],
        'rootAccount': json['root_account'] == null ? undefined : APIRootAccountFromJSON(json['root_account']),
    };
}

export function APIOrganizationAutocompleteSuggestionToJSON(value?: APIOrganizationAutocompleteSuggestion | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'vat_number': value['vatNumber'],
        'root_account': APIRootAccountToJSON(value['rootAccount']),
    };
}

